export default {
    namespaced:true,//命令空间必须有，否则该类会挂在根下。
    state: {
        loginSucc:false,
        btnDatas:{},
        menuData:[],
        tabViewMap: new Map(),  //主要用来通过code获取tabView对象，以确定展示的页面
        businessMap: new Map() //以map形式保存字典、客户列表、产品列表等
    },
    getters:{
        getLoginSucc(state){
            return state.loginSucc;
        },
        getBtnDatas(state){
            return state.btnDatas;
        },
        getMenuData(state){
            return state.menuData;
        },
        getTabViewMap(state){
            return state.tabViewMap;
        },
        getBusinessMap: (state) => (key) => {
            return state.businessMap.get(key);
        }
    },
    mutations: {
        SET_LOGIN_SUCC(state, data){
            state.loginSucc = data;
        },
        SET_BTN_DATA(state, data){
            state.btnDatas = data;
        },
        SET_MENU_DATA(state, data){
            state.menuData = data;
        },
        PUSH_OBJ_TO_TABVIEWMAP(state, viewObj){
            state.tabViewMap.set(viewObj.code,viewObj);
        },
        REMOVE_TABVIEW(state, viewObj){
            if(!state.tabViewMap.has(viewObj)){
                return null;
            }
            state.tabViewMap.delete(viewObj);
        },
        CLEAR_MAP(state){
            if(state.tabViewMap){
                state.tabViewMap.clear();
            }
        },
        SET_BUSINESS_MAP(state, data){
            state.businessMap.set(data.code,data);
        }
    },
    actions: {
        setLoginSucc({commit},data){
            commit('SET_LOGIN_SUCC',data);
        },
        setDtnDatas({commit},data){
            commit('SET_BTN_DATA',data);
        },
        setMenuData({commit},data){
            commit('SET_MENU_DATA',data);
        },
        
        addTabViewToMap({commit},viewObj){  
            viewObj.forEach(element => {
                commit('PUSH_OBJ_TO_TABVIEWMAP',element);
            });
        },
        removeViewObj({commit},viewObj){
            commit('REMOVE_TABVIEW',viewObj);
        },
        clearMap({commit}){
            commit('CLEAR_MAP');
        },
        setBusinessMap({commit},data){
            for(var kk in data){
              var element = data[kk];
              element.code = kk;
              commit('SET_BUSINESS_MAP',element);
            }
        }
    }
}
